import { useQuery } from "@tanstack/react-query";
import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";
import ReportIncidenService from "../../../components/api/ReportIncidenService";

export const DSR_DEADLINE_MANAGEMENT_FEATURE = "dsr-deadline-management";
const POLL_INTERVAL_MS = 60 * 1000;

export const getDsrDeadlineWorkflowQueryKey = (caseId) => [
  "dsr-deadline-workflow",
  caseId,
];

export const isDsrFlagOn = (value) => value === true || value === 1;

export const useDsrDeadlineWorkflow = (caseId) => {
  const isFeatureEnabled = isFeatureEnabledForActiveModule(
    DSR_DEADLINE_MANAGEMENT_FEATURE
  );

  const query = useQuery({
    queryKey: getDsrDeadlineWorkflowQueryKey(caseId),
    queryFn: async () => {
      const service = ReportIncidenService.getInstance();
      return await service.fetchDsrWorkflow(caseId);
    },
    enabled: isFeatureEnabled && !!caseId,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchInterval: (data) =>
      isDsrFlagOn(data?.is_awaiting_requester) ? POLL_INTERVAL_MS : false,
  });

  const isDeadlineManagementEnabled =
    isFeatureEnabled &&
    isDsrFlagOn(query.data?.dsr_deadline_management_enabled);

  return {
    ...query,
    isFeatureEnabled,
    isDeadlineManagementEnabled,
    isAwaitingRequester:
      isDeadlineManagementEnabled &&
      isDsrFlagOn(query.data?.is_awaiting_requester),
  };
};
